import { render, staticRenderFns } from "./View_Section_Admin.vue?vue&type=template&id=0a97b557&scoped=true"
import script from "./View_Section_Admin.vue?vue&type=script&lang=js"
export * from "./View_Section_Admin.vue?vue&type=script&lang=js"
import style0 from "./View_Section_Admin.vue?vue&type=style&index=0&id=0a97b557&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97b557",
  null
  
)

export default component.exports